import React from 'react';
import { useTranslate } from 'react-admin';
import RecordTitleButton from '~/components/RecordTitleButton';
import { ViewHistoryButton } from '~/components/Changelog';
import { getHintEditModeColor, useEditMode } from '~/hooks/useEditModeContext';
import { useDraft } from '~/hooks/useDraftContext';
import { history } from '~/App';

/**
 * "You are viewing your non-submitted draft … view the current version" line shown
 * in a record title. Renders nothing outside DRAFT mode.
 */
const DraftModeNotice = () => {
  const { editMode } = useEditMode();
  const { draft, page, recordId } = useDraft();

  const translate = useTranslate();
  const t = (key: string): string => translate(`components.RecordTitle.${key}`);

  if (editMode !== 'DRAFT') {
    return null;
  }

  // Back to the record this is a draft of, staying on the current tab.
  const gotoCurrentVersion = () => {
    history.push(`/${page?.resource}/${recordId}${page?.tabPath ?? '/show'}`);
  };

  return (
    <>
      <span style={{ color: getHintEditModeColor(editMode) }}>{t('draftWarning')}</span>
      {draft?.isUpdateDraft && (
        <>
          {t('view')}
          <RecordTitleButton label={t('current')} onClick={gotoCurrentVersion} />
          {'. '}
          <ViewHistoryButton />
        </>
      )}
    </>
  );
};

export default DraftModeNotice;
